// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__hEAc6","addWidgetButton":"Header_addWidgetButton__2J42S","dashboardTabs":"Header_dashboardTabs__1vgSf","active":"Header_active__2qCCp"};